import { dispatcher, api } from 'react-structure-admin';
import getEndpointByInvoiceModel from 'util/getEndpointByInvoiceModel';

export const INVOICE = 'INVOICE';
export const INVOICE_OPEN_CANCEL = 'INVOICE_OPEN_CANCEL';
export const INVOICE_CLOSE_CANCEL = 'INVOICE_CLOSE_CANCEL';
export const INVOICE_CANCEL = 'INVOICE_CANCEL';
export const INVOICE_CANCEL_FINISHED = 'INVOICE_CANCEL_FINISHED';
export const INVOICE_REFRESH = 'INVOICE_REFRESH';

export const INVOICE_OPEN_EVENTS = 'INVOICE_OPEN_EVENTS';
export const INVOICE_CLOSE_EVENTS = 'INVOICE_CLOSE_EVENTS';
export const INVOICE_GET_EVENTS = 'INVOICE_GET_EVENTS';
export const INVOICE_GET_EVENTS_FINISHED = 'INVOICE_GET_EVENTS_FINISHED';

export const INVOICE_OPEN_REMOVE = 'INVOICE_OPEN_REMOVE';
export const INVOICE_CLOSE_REMOVE = 'INVOICE_CLOSE_REMOVE';
export const INVOICE_REMOVE = 'INVOICE_REMOVE';
export const INVOICE_REMOVE_FINISHED = 'INVOICE_REMOVE_FINISHED';

export const INVOICE_CREATE_DISABLEMENT = 'INVOICE_CREATE_DISABLEMENT';
export const INVOICE_CREATE_DISABLEMENT_FINISHED =
  'INVOICE_CREATE_DISABLEMENT_FINISHED';

export const INVOICE_REFRESH_DISABLEMENT = 'INVOICE_REFRESH_DISABLEMENT';

export const INVOICE_OPEN_DEVOLUTION = 'INVOICE_OPEN_DEVOLUTION';
export const INVOICE_CLOSE_DEVOLUTION = 'INVOICE_CLOSE_DEVOLUTION';
export const INVOICE_DEVOLUTION = 'INVOICE_DEVOLUTION';
export const INVOICE_DEVOLUTION_FINISHED = 'INVOICE_DEVOLUTION_FINISHED';

export const INVOICE_OPEN_CORRECTION = 'INVOICE_OPEN_CORRECTION';
export const INVOICE_CLOSE_CORRECTION = 'INVOICE_CLOSE_CORRECTION';
export const INVOICE_CORRECTION = 'INVOICE_CORRECTION';
export const INVOICE_CORRECTION_FINISHED = 'INVOICE_CORRECTION_FINISHED';

export const INVOICE_OPEN_ISSUE = 'INVOICE_OPEN_ISSUE';
export const INVOICE_CLOSE_ISSUE = 'INVOICE_CLOSE_ISSUE';
export const INVOICE_ISSUE = 'INVOICE_ISSUE';
export const INVOICE_ISSUE_FINISHED = 'INVOICE_ISSUE_FINISHED';

export const INVOICE_ITEMS_SELECTED = 'INVOICE_ITEMS_SELECTED';
export const INVOICE_OPEN_ENQUEUE_CANCELLATION =
  'INVOICE_OPEN_ENQUEUE_CANCELLATION';
export const INVOICE_CLOSE_ENQUEUE_CANCELLATION =
  'INVOICE_CLOSE_ENQUEUE_CANCELLATION';
export const INVOICE_ENQUEUE_CANCELLATION = 'INVOICE_ENQUEUE_CANCELLATION';
export const INVOICE_ENQUEUE_CANCELLATION_FINISHED =
  'INVOICE_ENQUEUE_CANCELLATION_FINISHED';
export const INVOICE_OPEN_CANCEL_BATCH = 'INVOICE_OPEN_CANCEL_BATCH';
export const INVOICE_CLOSE_CANCEL_BATCH = 'INVOICE_CLOSE_CANCEL_BATCH';
export const INVOICE_CANCEL_BATCH_FINISHED = 'INVOICE_CANCEL_BATCH_FINISHED';
export const INVOICE_CANCEL_BATCH = 'INVOICE_CANCEL_BATCH';

export const INVOICE_OPEN_SEND_EMAIL = 'INVOICE_OPEN_SEND_EMAIL';
export const INVOICE_CLOSE_SEND_EMAIL = 'INVOICE_CLOSE_SEND_EMAIL';
export const INVOICE_SEND_EMAIL = 'INVOICE_SEND_EMAIL';
export const INVOICE_SEND_EMAIL_FINISHED = 'INVOICE_SEND_EMAIL_FINISHED';

export const openInvoiceCancel = (id, model) => (dispatch) => {
  dispatch(dispatcher.createAction(INVOICE_OPEN_CANCEL, 'invoices', id, model));
};

export const closeInvoiceCancel = () => (dispatch) => {
  dispatch(dispatcher.createAction(INVOICE_CLOSE_CANCEL, 'invoices'));
};

export const cancelInvoice = (data) => async (dispatch) => {
  const endpoint = getEndpointByInvoiceModel(data.model);
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'invoices',
    actionType: INVOICE_CANCEL,
    effect: async () => api.post(`${endpoint}/${data.id}/cancel`, { ...data })
  });
};

export const openInvoiceEvents = (id, number) => (dispatch) => {
  dispatch(
    dispatcher.createAction(INVOICE_OPEN_EVENTS, 'invoices', { id, number })
  );
};

export const closeInvoiceEvents = () => (dispatch) => {
  dispatch(dispatcher.createAction(INVOICE_CLOSE_EVENTS, 'invoices'));
};

export const getEvents = (invoice) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'invoices',
    actionType: INVOICE_GET_EVENTS,
    payload: invoice,
    effect: async () => api.fetch(`invoices/${invoice.id}/events`, {})
  });
};

export const openProductInvoiceCorrection = (id) => (dispatch) => {
  dispatch(dispatcher.createAction(INVOICE_OPEN_CORRECTION, 'invoices', id));
};

export const closeProductInvoiceCorrection = () => (dispatch) => {
  dispatch(dispatcher.createAction(INVOICE_CLOSE_CORRECTION, 'invoices'));
};

export const productInvoiceCorrection = (data) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'invoices',
    actionType: INVOICE_CORRECTION,
    effect: async () =>
      api.post(`product-invoices/${data.id}/correction`, { ...data })
  });
};

export const refresh = () => (dispatch) => {
  dispatch(dispatcher.createAction(INVOICE_REFRESH, 'invoices'));
};

export const openInvoiceRemove = (invoice, order) => (dispatch) => {
  dispatch(
    dispatcher.createAction(INVOICE_OPEN_REMOVE, 'invoices', { invoice, order })
  );
};

export const closeInvoiceRemove = () => (dispatch) => {
  dispatch(dispatcher.createAction(INVOICE_CLOSE_REMOVE, 'invoices'));
};

export const removeInvoice = (id) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'invoices',
    actionType: INVOICE_REMOVE,
    effect: async () => api.post(`invoices/${id}/remove`)
  });
};

export const createDisablements = (data, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'disablements',
    actionType: INVOICE_CREATE_DISABLEMENT,
    effect: async () => api.post('product-invoices/disablements', data),
    onSuccess
  });
};

export const refreshDisablements = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(INVOICE_REFRESH_DISABLEMENT, 'disablements')
  );
};

export const openIssue = (id) => (dispatch) => {
  dispatch(dispatcher.createAction(INVOICE_OPEN_ISSUE, 'invoices', id));
};

export const closeIssue = () => (dispatch) => {
  dispatch(dispatcher.createAction(INVOICE_CLOSE_ISSUE, 'invoices'));
};

export const issue = (data) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'invoices',
    actionType: INVOICE_ISSUE,
    effect: async () => api.post('invoices/issue', data)
  });
};

export const openInvoiceDevolution = (invoice, order) => (dispatch) => {
  dispatch(
    dispatcher.createAction(INVOICE_OPEN_DEVOLUTION, 'invoices', {
      invoice,
      order
    })
  );
};

export const closeInvoiceDevolution = () => (dispatch) => {
  dispatch(dispatcher.createAction(INVOICE_CLOSE_DEVOLUTION, 'invoices'));
};

export const devolveInvoice = (id, data) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'invoices',
    actionType: INVOICE_DEVOLUTION,
    effect: async () => api.post(`product-invoices/${id}/devolution`, data)
  });
};

export const cancelBatch = (data, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'invoices',
    actionType: INVOICE_CANCEL_BATCH,
    effect: async () => api.post('invoices/cancel-batch', data),
    onSuccess
  });
};

export const selectedRows = (items = []) => (dispatch) => {
  dispatch(dispatcher.createAction(INVOICE_ITEMS_SELECTED, 'invoices', items));
};

export const openEnqueueCancellation = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(INVOICE_OPEN_ENQUEUE_CANCELLATION, 'invoices')
  );
};

export const closeEnqueueCancellation = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(INVOICE_CLOSE_ENQUEUE_CANCELLATION, 'invoices')
  );
};

export const enqueueCancellation = (data, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'invoices',
    actionType: INVOICE_ENQUEUE_CANCELLATION,
    effect: async () => api.post('invoices/enqueue-cancellation', data),
    onSuccess
  });
};

export const openInvoiceCancelBatch = (invoicesIds) => (dispatch) => {
  dispatch(
    dispatcher.createAction(INVOICE_OPEN_CANCEL_BATCH, 'invoices', invoicesIds)
  );
};

export const closeInvoiceCancelBatch = () => (dispatch) => {
  dispatch(dispatcher.createAction(INVOICE_CLOSE_CANCEL_BATCH, 'invoices'));
};

export const openInvoiceEmail = (invoice) => (dispatch) => {
  dispatch(
    dispatcher.createAction(INVOICE_OPEN_SEND_EMAIL, 'invoices', invoice)
  );
};

export const closeInvoiceEmail = () => (dispatch) => {
  dispatch(dispatcher.createAction(INVOICE_CLOSE_SEND_EMAIL, 'invoices'));
};

export const sendInvoiceEmail = (data, onSuccess) => async (dispatch) => {
  const endpoint = getEndpointByInvoiceModel(data.model);
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'invoices',
    actionType: INVOICE_SEND_EMAIL,
    effect: async () =>
      api.post(`${endpoint}/${data.id}/resend-email`, { ...data }),
    onSuccess
  });
};
